"use strict";

exports.__esModule = true;
exports.ReportToolbar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Core = require("../../Core");
var _Auth = require("../../Auth");
var _URLFilter = require("../../Core/URLFilter");
var _ReportingPeriod = require("../../Time/ReportingPeriod");
var _System = require("../../../System");
var _Device = require("../../Device");
var _MultiDeviceSelector = require("../../Device/MultiDeviceSelector/MultiDeviceSelector");
var _Time = require("../../Time");
var _CalendarContext = require("../../Calendar/CalendarContext");
var _utils = require("../../Calendar/utils");
var _EnvContext = require("../../Env/EnvContext");
var _PlantTwinFilter = require("../../Filters/PlantTwinFilter");
var _DeviceTypeFilter = require("../../Filters/DeviceTypeFilter");
var _DeviceTagFilter = require("../../Filters/DeviceTagFilter");
var _AiEditButton = require("../../AI/Authoring/AiEditButton");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _ReportToolbar;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Toolbar for specific reports.
 */
var ReportToolbar = exports.ReportToolbar = (_dec = _Time.TimeContext.withContext, _dec2 = _CalendarContext.CalendarContext.withContext, _dec3 = _URLFilter.URLFilterContext.withContext, _dec4 = _ReportingPeriod.ReportingPeriodContext.withContext, _dec5 = _Device.DeviceTagListContext.withContext, _dec6 = _EnvContext.EnvContext.withContext, _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = (_ReportToolbar = /*#__PURE__*/function (_Component) {
  function ReportToolbar() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.ensureDefaultDevice = function () {
      if (_this._defaultDeviceRequested) {
        return;
      }
      var _this$props = _this.props,
        report = _this$props.report,
        devices = _this$props.devices,
        urlFilter = _this$props.urlFilter;
      if (!report || !urlFilter || !devices || !devices[0]) {
        return;
      }
      var filters = urlFilter.filters,
        setFilter = urlFilter.setFilter;
      var isDeviceDetails = report.element.type === "DeviceDetails";
      if (isDeviceDetails && !filters.device) {
        _this._defaultDeviceRequested = true;
        setFilter("device", devices[0].uuid);
      }
    };
    return _this;
  }
  _inheritsLoose(ReportToolbar, _Component);
  var _proto = ReportToolbar.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.ensureDefaultDevice();
  };
  _proto.componentDidUpdate = function componentDidUpdate() {
    this.ensureDefaultDevice();
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      report = _this$props2.report,
      devices = _this$props2.devices,
      deviceTags = _this$props2.deviceTags,
      time = _this$props2.time,
      urlFilter = _this$props2.urlFilter,
      calendar = _this$props2.calendar.calendar,
      reportingPeriod = _this$props2.reportingPeriod,
      env = _this$props2.env;
    var filters = urlFilter.filters,
      setFilter = urlFilter.setFilter;
    var isDeviceDetails = report.element.type === "DeviceDetails";
    var currentPlantWorkdayId = (0, _utils.getDate)(time.currentWorkday.interval.endMillis);
    var isSingleDay = report.element.props.timeRangeKind === "singleDay";
    var start = (0, _utils.startOfDay)(calendar.getWorkdayAt(reportingPeriod.interval.startMillis).id);
    var end = (0, _utils.endOfDay)(calendar.getWorkdayAt(reportingPeriod.interval.endMillis - 1).id);
    var renderMultiDeviceSelector = function renderMultiDeviceSelector() {
      return /*#__PURE__*/_react["default"].createElement(_Auth.AccessCheck, {
        permission: "PLANT_TWIN"
      }, function (_ref) {
        var isAllowed = _ref.isAllowed;
        if (isAllowed) {
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_PlantTwinFilter.PlantTwinFilter, {
            property: "device",
            showItemCount: true
          }), /*#__PURE__*/_react["default"].createElement(_DeviceTagFilter.DeviceTagFilter, null), /*#__PURE__*/_react["default"].createElement(_DeviceTypeFilter.DeviceTypeFilter, null));
        }
        return /*#__PURE__*/_react["default"].createElement(_MultiDeviceSelector.MultiDeviceSelector, {
          showItemCount: true,
          style: {
            maxWidth: 200
          },
          devices: devices,
          tags: deviceTags,
          selectAllByDefault: false,
          shouldSelectAllFiltered: true,
          selected: filters.device,
          onSelect: function onSelect(devices) {
            return setFilter("device", devices.map(function (device) {
              return device.uuid;
            }));
          }
        });
      });
    };
    var renderDeviceSelector = function renderDeviceSelector() {
      if (isDeviceDetails) {
        var selectedDevice = filters.device || devices && devices[0] && devices[0].uuid || undefined;
        return /*#__PURE__*/_react["default"].createElement(_Device.DeviceSelector, {
          disabled: env && env.featureFlags ? env.featureFlags.includes("DISABLE_REPORT_SINGLE_DEVICE_SELECTOR") : false,
          items: devices,
          selected: selectedDevice ? [selectedDevice] : [],
          onSelect: function onSelect(_ref2) {
            var device = _ref2[0];
            return setFilter("device", device.uuid);
          }
        });
      }
      return renderMultiDeviceSelector();
    };
    var renderWorkdaySelector = function renderWorkdaySelector() {
      if (isSingleDay) {
        return /*#__PURE__*/_react["default"].createElement(_Time.WorkdaySelectorPopover, {
          maxDate: currentPlantWorkdayId,
          selected: [start],
          onSelect: function onSelect(selected) {
            if (selected.length === 0) {
              return;
            }
            var interval = calendar.getIntervalForWorkdays((0, _utils.toDateString)(selected));
            var parts = [new Date(interval.startMillis).toISOString(), new Date(interval.endMillis).toISOString()];
            return setFilter("period", parts.join("/"));
          }
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_Time.WorkdayRangeSelector, {
        maxDate: currentPlantWorkdayId,
        selected: [start, end],
        onSelect: function onSelect(selected) {
          if (selected.length === 0) {
            return;
          }

          // This can result in the days incrementing/decrementing from what the user selected
          var interval = calendar.getIntervalForWorkdays((0, _utils.toDateString)(selected));
          var parts = [new Date(interval.startMillis).toISOString(), new Date(interval.endMillis).toISOString()];
          return setFilter("period", parts.join("/"));
        }
      });
    };
    return /*#__PURE__*/_react["default"].createElement(_Core.Toolbar, {
      "data-testid": "ReportToolbar"
    }, /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
      minimal: true
    }, renderDeviceSelector(), renderWorkdaySelector()), /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
      permission: "EDIT_REPORTS"
    }, /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
      style: {
        marginLeft: "auto"
      },
      to: (0, _System.getScreenURL)("UpdateReport", report, (0, _System.compactQuery)(this.props.urlFilter && this.props.urlFilter.filters)),
      icon: _icons.IconNames.EDIT,
      minimal: true,
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "ReportToolbar.updateReportButton.text",
        defaultMessage: "Edit Report"
      })
    })), /*#__PURE__*/_react["default"].createElement(_AiEditButton.AiEditButton, {
      kind: "report",
      document: report,
      onReload: this.props.onReload
    }));
  };
  return ReportToolbar;
}(_react.Component), _ReportToolbar.defaultProps = {
  calendar: undefined,
  time: undefined,
  urlFilter: undefined,
  reportingPeriod: undefined,
  deviceTags: undefined
}, _ReportToolbar)) || _class) || _class) || _class) || _class) || _class) || _class);